import { render, staticRenderFns } from "./rental.vue?vue&type=template&id=822b40e2&scoped=true"
import script from "./rental.vue?vue&type=script&lang=js"
export * from "./rental.vue?vue&type=script&lang=js"
import style0 from "./rental.vue?vue&type=style&index=0&id=822b40e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822b40e2",
  null
  
)

export default component.exports